import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-api-button',
  templateUrl: './api-button.component.html',
  styleUrls: ['./api-button.component.scss']
})
export class ApiButtonComponent implements OnInit {

  @Input() color: 'success' | 'info' | 'warning' | 'default' = 'success'
  @Input() processing: boolean = false
  @Input() disabled: boolean = false

  @Output() click2: EventEmitter<void> = new EventEmitter<void>();

  constructor() { }

  ngOnInit() {
  }

  onClick() {
    if (!this.processing) {
      this.click2.emit()
    }
  }

}
